export const environment = {
  production: false,
  title: 'Development Environment Heading',
  clientId: '09236616-59df-46d7-8189-877d0b089338',
  apiURL: '/api/',
  baseUrl: 'https://storecom-test.matas.dk/',
  mailPreviewBaseUrl: 'https://web-obt-weu-dev-staging.azurewebsites.net',
  agillicEmailKeys: '#{activityModuleAgillicEmailKey}#',
};
